/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

export const PreviewRow = function ({
  label,
  text,
}: {
  label: string;
  text: string;
}) {
  if (!text) return null;
  return (
    <div className="flex flex-col">
      <span className="pb-1 text-[12px] text-form-input-disabled">{label}</span>
      <span className="line-clamp-1 break-all text-[12px] text-body-subtle">
        {text}
      </span>
    </div>
  );
};
